module.exports = __webpack_public_path__ + "img/nav-video-script-icon.6450ef0a.svg";